import React, { useEffect, useRef } from "react";
import { Warning } from "@phosphor-icons/react";
import { trackAnalytics } from "src/pages/helpers";
import { EVENT_NAMES, EVENT_PARAMETERS, BANNER_TYPES } from "src/utils/EventConstants";

export const DEFAULT_OUTAGE_MESSAGE =
  "We're experiencing technical issues — some chats may fail to regenerate. Please try again in about 2 hours.";

/**
 * App-wide, non-dismissible incident notice.
 *
 * DEFAULT-ON: this ships during an active incident, so it renders unless
 * REACT_APP_SERVICE_OUTAGE is explicitly "false". Set that env var (or revert
 * this commit) once the outage clears.
 *
 * Note: CRA inlines process.env at build time, so flipping the flag needs a redeploy.
 */
const ServiceOutageBanner = () => {
  const isOutage = process.env.REACT_APP_SERVICE_OUTAGE !== "false";
  const hasTracked = useRef(false);

  useEffect(() => {
    if (!isOutage || hasTracked.current) return;
    hasTracked.current = true;
    trackAnalytics(EVENT_NAMES.VIEWED_BANNER, {
      [EVENT_PARAMETERS.BANNER_TYPE]: BANNER_TYPES.SERVICE_OUTAGE,
    });
  }, [isOutage]);

  if (!isOutage) return null;

  const message = process.env.REACT_APP_SERVICE_OUTAGE_MESSAGE || DEFAULT_OUTAGE_MESSAGE;

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-center justify-center gap-2 px-4 py-2.5 bg-[#B45309] text-white text-[14px] text-center"
    >
      <Warning size={16} weight="fill" className="flex-shrink-0" aria-hidden="true" />
      <span>{message}</span>
    </div>
  );
};

export default ServiceOutageBanner;
